<script lang="ts">
  import type { MediaKitLandingPage } from '$lib/sanity/schemas';
  import { ResponsiveVars, TwistDivider } from '@twist/core';
  import { BGMode } from '$components/News/Background/BackgroundGradient.svelte';
  import GlowFilter from '$components/News/Headers/GlowFilter.svelte';
  import Container from '../News/Container.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import {
    useEncodeDataAttribute,
    type ContentSourceMap,
    type StudioPathLike
  } from '@sanity/svelte-loader';
  import { sanityStudioURL } from '$lib/client';

  export let document: MediaKitLandingPage;
  export let sourceMap: ContentSourceMap | undefined;
  export let path: StudioPathLike = [];

  $: encodeDataAttribute = useEncodeDataAttribute(document, sourceMap, sanityStudioURL);

  const responsiveVars = new ResponsiveVars()
    .addFluid('header-padding-top', toFluidVarInput(140, 200))
    .addFluid('header-padding-bottom', toFluidVarInput(30, 60))
    .addFluid('h-font-size', [
      ['min', 68],
      ['sm', 'lg', 68, 72],
      ['lg', 'max', 72, 96],
      ['max', 96]
    ])
    .addFluid('h-py', [
      ['min', 48],
      ['lg', 'max', 48, 64],
      ['max', 64]
    ])
    .toCSS();
</script>

<header
  class={responsiveVars}
  data-background
  data-bgmode={BGMode.SINGLE}
  data-bgcolor1={document?.header?.bgColor}
>
  <Container>
    <GlowFilter />
    <h1 data-sanity={encodeDataAttribute([...path, 'header', 'title'])}>
      {document?.header?.title}
    </h1>
    <TwistDivider thickness="1px" margin={0} />
  </Container>
</header>

<style lang="scss">
  @import 'src/scss/media';

  header {
    padding-top: var(--header-padding-top);
    padding-bottom: var(--header-padding-bottom);
  }

  h1 {
    color: var(--twist-color-gray-100);
    font-family: var(--font-family-primary);
    font-weight: 700;
    filter: url(#glow);
    -webkit-filter: url(#glow);
    font-size: var(--h-font-size);
    padding: var(--h-py) 0;
  }
</style>
